export let IndexType = /*#__PURE__*/function (IndexType) {
  IndexType["numeric"] = "numeric";
  IndexType["enum"] = "enum";
  IndexType["text"] = "text";
  return IndexType;
}({});
export const indexTypes = Object.keys(IndexType);